import { ColorPalette } from "../../../config/colors"

import { Component } from "react"
import Radium from "radium"
import ButtonBlue from "../../BaseComponents/Buttons/ButtonBlue"
import FilterButton from "../../BaseComponents/Buttons/FilterButton"
import ButtonGrey from "../../BaseComponents/Buttons/ButtonGrey"
import { CustomFilterState } from "../../Tables/DataTable/DataTable"
import { FilterService } from "../../../services"

const filterService = new FilterService()

type FieldFilterProps = {
  filtersOnLoad: CustomFilterState[]
  filterConfig: { key: string; label: string }[]
  onDoneClick: (updatedFilters: CustomFilterState[]) => void
}

type FieldFilterState = {
  fieldOptions: string[]
  warningIndices: number[]
  filterOptions: string[]
  filters: CustomFilterState[]
}

class FieldFilter extends Component<FieldFilterProps, FieldFilterState> {
  state: FieldFilterState = {
    fieldOptions: [],
    warningIndices: [],
    filterOptions: [],
    filters: [],
  }

  componentDidMount() {
    const { filterConfig, filtersOnLoad } = this.props
    const fieldOptions = [...filterConfig].map((item) => item.label)
    this.setState({ fieldOptions })
    this.stateUpdateHandler(filtersOnLoad)
  }

  addFilter = (e: React.MouseEvent) => {
    const { filters } = this.state
    e.stopPropagation()
    const updatedFilters = [
      {
        selectedField: "",
        filterType: "=",
        filterValue: "",
        key: "",
      },
      ...filters,
    ]
    this.stateUpdateHandler(updatedFilters)
  }

  removeAllFilters = () => {
    this.setState({ warningIndices: [], filters: [] })
  }

  deleteFilter = (e: React.MouseEvent, index: number) => {
    e.stopPropagation()
    let { warningIndices, filters } = this.state
    const updatedFilters = [...filters].filter((item, i) => i !== index)
    warningIndices = [...warningIndices].filter((warningIndex) => warningIndex !== index)
    this.setState({ warningIndices, filters: updatedFilters })
  }

  setFilterField = (index: number, result: string) => {
    if (result.length) {
      const { filters } = this.state
      const updatedFilters = [...filters].map((filterItem, i) => {
        if (i === index) {
          filterItem.selectedField = result
        }
        return filterItem
      })
      this.stateUpdateHandler(updatedFilters)
    }
  }

  toggleFilterType = (index: number) => {
    const { filters } = this.state
    const updatedFilters = [...filters].map((filterItem, i) => {
      if (i === index) {
        if (filterItem.filterType === "=") {
          filterItem.filterType = "<="
        } else if (filterItem.filterType === "<=") {
          filterItem.filterType = ">="
        } else {
          filterItem.filterType = "="
        }
      }
      return filterItem
    })
    this.stateUpdateHandler(updatedFilters)
  }

  setFilterValue = (index: number, text: string) => {
    const { filters } = this.state
    const updatedFilters = [...filters].map((filterItem, i) => {
      if (i === index) {
        filterItem.filterValue = text
      }
      return filterItem
    })
    this.stateUpdateHandler(updatedFilters)
  }

  stateUpdateHandler = (filterState: CustomFilterState[]) => {
    try {
      const { filterConfig } = this.props
      let warningIndices = [] as number[]
      let updatedFilterState = [...filterState].map((filterItem, index) => {
        filterConfig.forEach((item) => (item.label === filterItem.selectedField ? (filterItem.key = item.key) : null))
        if (
          isNaN(parseInt(filterItem.filterValue)) &&
          (filterItem.filterType === ">=" || filterItem.filterType === "<=") &&
          isNaN(Date.parse(filterItem.filterValue))
        ) {
          warningIndices = [...warningIndices, index]
        }
        return filterItem
      })
      this.setState({ warningIndices, filters: updatedFilterState })
    } catch (error) {
      // console.log("error: ", error)
    }
  }

  onDoneClick = () => {
    const { filters } = this.state
    const cleanedFilters = filterService.cleanFilterState(filters)
    this.props.onDoneClick(cleanedFilters)
  }

  generateFilterList = () => {
    const { warningIndices, filters } = this.state
    if (!filters.length) {
      return null
    }
    const filterButtonArray = filters.map((item, index) => {
      let warning = false
      if (warningIndices.includes(index)) {
        warning = true
      }

      return (
        <FilterButton
          filterType={item.filterType}
          filterValue={item.filterValue}
          selectedField={item.selectedField}
          setFilterField={(result) => this.setFilterField(index, result)}
          toggleFilterType={() => this.toggleFilterType(index)}
          textHandler={(text) => this.setFilterValue(index, text)}
          deleteFilter={(e) => this.deleteFilter(e, index)}
          fields={this.state.fieldOptions}
          warning={warning}
        />
      )
    })
    return <div style={styles.filterButtonArrayContainer}>{filterButtonArray}</div>
  }

  render() {
    const filterList = this.generateFilterList()
    let removeAllFiltersButton = null
    const numberOfFilters = this.state.filters.length

    const applyFiltersButton = (
      <ButtonBlue
        style={{ ...styles.button }}
        onClick={(e: React.MouseEvent) => {
          e.stopPropagation()
          this.onDoneClick()
        }}>
        Done
      </ButtonBlue>
    )

    if (numberOfFilters > 1) {
      removeAllFiltersButton = (
        <ButtonGrey
          style={{ ...styles.button, marginBottom: 12 }}
          onClick={(e: React.MouseEvent) => {
            e.stopPropagation()
            this.removeAllFilters()
          }}>
          Reset
        </ButtonGrey>
      )
    }

    return (
      <div style={{ ...styles.filterMenuContainer }}>
        <h1 style={{ ...styles.textStyle }}> Filters</h1>
        <div style={{ ...styles.dividerLine }} />
        <ButtonGrey style={{ ...styles.button, marginTop: 10, marginBottom: 12 }} onClick={this.addFilter}>
          + Add filter
        </ButtonGrey>
        {filterList}
        {removeAllFiltersButton}
        {applyFiltersButton}
      </div>
    )
  }
}

const styles = {
  filterMenuContainer: {
    display: "flex",
    flexDirection: "column" as "column",
    alignItems: "center",
    zIndex: 4,
    width: window.innerWidth * 0.4,
    backgroundColor: ColorPalette.CARD_WHITE,
    paddingTop: 15,
    paddingBottom: 40,
    paddingLeft: 20,
    paddingRight: 20,
    borderRadius: 8,
    maxHeight: window.innerHeight * 0.8,
    cursor: "default",
  },
  filterButtonArrayContainer: {
    marginBottom: 50,
    width: "94%",
    display: "flex",
    flexDirection: "column" as "column",
    alignItems: "center",
  },
  drawerButton: {
    display: "flex",
    alignItems: "center",
    fontSize: "0.9rem",
    fontFamily: "Roboto",
    fontWeight: "500",
    color: ColorPalette.PRIMARY_LIGHT_TEXT,
    backgroundColor: "rgba(255, 255, 255, 0)",
    height: "100%",
    width: "100%",
    outline: 0,
    border: `0px solid rgba(255,255,255,0)`,
    ":hover": {
      filter: "brightness(90%)",
    },
    ":active": {
      filter: "brightness(80%)",
    },
  },
  textStyle: {
    textAlign: "center" as "center",
    alignSelf: "center",
    fontFamily: "roboto",
    fontWeight: "bold",
    color: ColorPalette.PRIMARY_TEXT,
    paddingLeft: 10,
    paddingRight: 10,
    fontSize: "1.2rem",
  },
  dividerLine: {
    width: "86%",
    alignSelf: "center",
    marginTop: 10,
    marginBottom: 10,
    borderBottom: `1px solid ${ColorPalette.PRIMARY_BLUE}`,
  },
  button: {
    width: "92%",
    cursor: "pointer",
  },
}

export default Radium(FieldFilter)
